import { render, staticRenderFns } from "./DomainIgnoredUrls.vue?vue&type=template&id=7c2286dc&scoped=true&"
import script from "./DomainIgnoredUrls.vue?vue&type=script&lang=js&"
export * from "./DomainIgnoredUrls.vue?vue&type=script&lang=js&"
import style0 from "./DomainIgnoredUrls.vue?vue&type=style&index=0&id=7c2286dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2286dc",
  null
  
)

export default component.exports